import { changeValByPath, getValByPath, modifyData } from "@utils";
import { action, observable, makeObservable, toJS, runInAction, reaction } from "mobx";

import moment from "moment";
import { _getByUrlData, _postByUrlData, _putByUrlData, _deleteByUrlData, _uploadImage, _uploadFile } from "./service";

const defaultFilter = {
    filters: {
        active: "true",
        archived: "false",
        draft: "false",
        title: "",
        name: "",
        siteIds: null,
        vendorId: null,
        activationsDate: null,
    },
    projects: {},
    first: 0,
    rows: 2000000,
    sortField: "_id",
    sortOrder: "dsc",
    startDate: moment(new Date()).format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
};

class MainStore {
    mainStore = {
        initialApp: false,
        loader: false,
        toast: false,
        auth: false,
        modal: false,
        filter: defaultFilter,
        filial: false,
        suggest: {
            vendors_suggest: false,
            sites_suggest: false,
            categories_suggest: false,
            apisendings_suggest: false,
            metrostationsIds_suggest: false,
            cityIds_suggest: false,
            regionIds_suggest: false,
            offers_suggest: false,
            promo_kktuCategory_suggest: false,
            buckets_suggest: false,
            managers_suggest: false,
        },
        modified: {
            vendors_suggest: false,
            sites_suggest: false,
            categories_suggest: false,
            apisendings_suggest: false,
            metrostationsIds_suggest: false,
            cityIds_suggest: false,
            regionIds_suggest: false,
            offers_suggest: false,
            promo_kktuCategory_suggest: false,
            buckets_suggest: false,
            managers_suggest: false,
        },
        detailData: {},
        detaiDeflData: {},
        eridToRegenerate: null,
    };

    constructor(props) {
        makeObservable(this, {
            mainStore: observable,
            setMainStore: action,
            setDefaultFilter: action,
        });

        // Реакция для вызова функций-запросов после авторизации
        reaction(
            // data function -  следит за значением mainStore.auth
            () => this.mainStore.auth,

            // effect function -  вызывается при изменении значения
            async (auth, prevAuth) => {
                // Если авторизовался то кидаем запрос на все suggests
                if (auth && !prevAuth) {
                    await this.getSuggests();
                }
            },
        );
    }

    initStore = async () => {
        if (localStorage.getItem("_cms_token_v1")) {
            const req = await this.getByUrl("admin/authorization", false, "auth");

            if (req.success && req.token) {
                localStorage.setItem("_cms_token_v1", req.token);
            } else {
                localStorage.removeItem("_cms_token_v1");
            }

            this.setMainStore("initialApp", true);
        }
    };

    getSuggests = async () => {
        const managers_suggest = await this.getByUrl("/cms/suggest_list?collection=users&filters[isRisManager]=true&project[fullName]=1", false, "suggest.managers_suggest", true, false);
        if (managers_suggest.success && managers_suggest.data) this.setMainStore("modified.managers_suggest", modifyData(managers_suggest.data, "_id"));

        const promo_kktuCategory_suggest = await this.getByUrl("/promo/kktucategories", false, "suggest.promo_kktuCategory_suggest", false);
        if (promo_kktuCategory_suggest.success && promo_kktuCategory_suggest.data) this.setMainStore("modified.promo_kktuCategory_suggest", modifyData(promo_kktuCategory_suggest.data, "_id"));

        const offers_suggest = await this.getByUrl(
            "/promo/suggest_list?collection=offers&project[title]=1&project[technicalName]=1&project[active]=1&project[archived]=1&project[vendorId]=1&project[bucketCode]=1&project[ratesArray]=1",
            false,
            "suggest.offers_suggest",
            false,
        );
        if (offers_suggest.success && offers_suggest.data) this.setMainStore("modified.offers_suggest", modifyData(offers_suggest.data, "_id"));

        const vendors_suggest = await this.getByUrl("/promo/suggest_list?collection=vendors&project[_id]=1&project[code]=1&project[name]=1&filters[active]=true", false, "suggest.vendors_suggest", true, false);
        if (vendors_suggest.success && vendors_suggest.data) this.setMainStore("modified.vendors_suggest", modifyData(vendors_suggest.data, "_id"));

        const sites_suggest = await this.getByUrl(
            "/promo/suggest_list?collection=sites&project[_id]=1&project[code]=1&project[name]=1&sortField=name&sortOrder=asc&filters[active]=true&project[siteInfo]=1",
            false,
            "suggest.sites_suggest",
            true,
            false,
        );
        if (sites_suggest.success && sites_suggest.data) this.setMainStore("modified.sites_suggest", modifyData(sites_suggest.data, "_id"));

        const categories_suggest = await this.getByUrl("/promo/suggest_list?collection=categories&project[_id]=1&project[code]=1&project[title]=1", false, "suggest.categories_suggest", true, false);
        if (categories_suggest.success && categories_suggest.data) this.setMainStore("modified.categories_suggest", modifyData(categories_suggest.data, "_id"));

        const apisendings_suggest = await this.getByUrl("/promo/suggest_list?collection=apisendings&project[_id]=1&project[code]=1&project[title]=1", false, "suggest.apisendings_suggest", true, false);
        if (apisendings_suggest.success && apisendings_suggest.data) this.setMainStore("modified.apisendings_suggest", modifyData(apisendings_suggest.data, "_id"));

        const metrostationsIds_suggest = await this.getByUrl("/supply/suggest_list?collection=metrostations&project[_id]=1&project[name]=1&project[parentId]=1&project[parentType]=1", false, "suggest.metrostationsIds_suggest", true, false);
        if (metrostationsIds_suggest.success && metrostationsIds_suggest.data) this.setMainStore("modified.metrostationsIds_suggest", modifyData(metrostationsIds_suggest.data, "_id"));

        const cityIds_suggest = await this.getByUrl("/supply/suggest_list?collection=cities&project[_id]=1&project[city]=1&project[regionId]=1", false, "suggest.cityIds_suggest", true, false);
        if (cityIds_suggest.success && cityIds_suggest.data) this.setMainStore("modified.cityIds_suggest", modifyData(cityIds_suggest.data, "_id"));

        const regionIds_suggest = await this.getByUrl("/supply/suggest_list?collection=regions&project[_id]=1&project[name_with_type]=1&project[title]=1", false, "suggest.regionIds_suggest", true, false);
        if (regionIds_suggest.success && regionIds_suggest.data) this.setMainStore("modified.regionIds_suggest", modifyData(regionIds_suggest.data, "_id"));

        const buckets_suggest = await this.getByUrl("/promo/suggest_list?collection=buckets&project[_id]=1&project[code]=1&project[title]=1&project[vendorId]=1", false, "suggest.buckets_suggest", true, false);
        if (buckets_suggest.success && buckets_suggest.data) this.setMainStore("modified.buckets_suggest", modifyData(buckets_suggest.data, "_id"));
    };

    getByUrl = (url, data, key, cda, loader, toast) => this.fetchWithLoader(() => _getByUrlData(url, data, cda), key, loader, toast);
    postByUrl = (url, data, key, cda, loader, isFile) => this.fetchWithLoader(() => _postByUrlData(url, data, cda, isFile), key, loader);
    putByUrl = (url, data, key, loader) => this.fetchWithLoader(() => _putByUrlData(url, data), key, loader);
    deleteByUrl = (url, data, key, cda, loader) => this.fetchWithLoader(() => _deleteByUrlData(url, data, cda), key, loader);
    uploadFile = (url, file, options, cda, loader, toast) => this.fetchWithLoader(() => _uploadFile(url, file, options, cda), "", loader, toast);

    fetchWithLoader = async (func, key = "", loader = true, toast = true) => {
        loader && this.setMainStore("loader", true);
        const res = await func();
        loader && this.setMainStore("loader", false);

        if (typeof res == "object" && !res.success && !(res instanceof Blob)) {
            if (toast) this.setMainStore("toast", { severity: "error", life: 400000, summary: "Ошибка", detail: res.msg || res.data });
        } else if (key) {
            this.setMainStore(key, res.data);
        }

        return res;
    };

    getMainStore = (key) => {
        if (!key) return;
        return getValByPath(key, this.mainStore);
    };

    setMainStore = (key, value) => {
        changeValByPath(key, value, this.mainStore, true);
    };

    setDefaultFilter = () => {
        this.mainStore.filter = defaultFilter;
    };

    uploadImage = async (url, file) => {
        this.setMainStore("loader", true);
        const res = await _uploadImage(url, file);
        this.setMainStore("loader", false);
        return res;
    };

    downloadFile = async (url, file, options, name, cda) => {
        const resp = await this.uploadFile(url, file, options, cda);

        if (typeof resp === "object" && !resp.success && !(resp instanceof Blob)) {
            return;
        }

        if (resp) {
            const blob = resp instanceof Blob ? resp : new Blob([resp]);
            const fileName = `${name}`;
            const elem = window.document.createElement("a");
            elem.href = window.URL.createObjectURL(blob);
            elem.download = fileName;
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
            this.setMainStore("toast", { severity: "success", summary: `Готово`, detail: "Все ваши файлы загружены" });
        }
    };

    logOut = () => {
        localStorage.removeItem("_cms_token_v1");
        this.setMainStore("initialApp", false);
        this.setMainStore("auth", false);
    };
}
export default new MainStore();
